import { GeracaoArquivoService } from '../../folha-pagamento/src/geracao-arquivo/geracao-arquivo.service';
import { MatriculaSidebarService } from './common/services/matriculas-sidebar.service';
import { KeycloakAuthConfig } from './keycloak/keycloak-auth-config';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { KEYCLOAK_AUTH_RESOURCES_CONFIG, WindowService } from '@elotech/angular-common';
import {
  ConfiguracaoEntidadeObservable,
  KeycloakAuthHttp,
  PageForbiddenModule,
} from '@elotech/angular-common';
import { AppComponent } from './app.component';
import { routing } from './app.routing';
import { ServidorSidebarModule } from './common/components/funcionario-sidebar/servidor-sidebar.module';
import { EntidadeService } from './common/services/entidade.service';
import { ExercicioService } from './exercicio/exercicio.service';
import { SharedModule } from './shared/shared.module';
import { UsuarioService } from './usuario/usuario.service';
import { FuncionarioSidebarModule } from '../../folha-pagamento/src/common/components/funcionario-sidebar/funcionario-sidebar.module';
import { ArquivoService } from 'projects/folha-pagamento/src/geracao-arquivo/arquivo.service';
import {
  CentralPortalServidorService
} from "../../folha-pagamento/src/central-portal-servidor/central-portal-servidor.service";
import {GruposPermitidosService} from "./central-portal-servidor/grupos-permitidos.service";
import { ConfiguracaoGeralRelatorioService } from '../../folha-pagamento/src/configuracao-geral/adicionar-relatorio/configuracao-geral-relatorio.service';

@NgModule({
  imports: [
    PageForbiddenModule,
    BrowserModule,
    ServidorSidebarModule,
    SharedModule.forRoot(),
    routing,
    FuncionarioSidebarModule,
  ],
  providers: [
    KeycloakAuthHttp,
    { provide: KEYCLOAK_AUTH_RESOURCES_CONFIG, useClass: KeycloakAuthConfig },
    ConfiguracaoEntidadeObservable,
    EntidadeService,
    ExercicioService,
    UsuarioService,
    MatriculaSidebarService,
    GeracaoArquivoService,
    ArquivoService,
    WindowService,
    CentralPortalServidorService,
    GruposPermitidosService,
    ConfiguracaoGeralRelatorioService
  ],
  declarations: [AppComponent],
  bootstrap: [AppComponent],
})
export class AppModule {}
